import React, { useRef, useState } from 'react';
import DataGrid, { Column, Pager, Paging, FilterRow, Editing, Lookup, Toolbar, Item, DataGridRef, Button as GridButton} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import { customersDataSource } from '../../datasources/customersDataSource';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import PopupDipendenze, { DipendenzePopupHandle } from '../../components/popupDipendenze/popupDipendenze';
import PopupEditCustomer, { EditCustomerPopupHandle } from '../../components/popupEditCustomer/popupEditCustomer';
import { useTranslation } from 'react-i18next';

export default function Customer() {
  const { t } = useTranslation();
  const dipendenzeRef = useRef<DipendenzePopupHandle>(null);
  const editCustomerRef = useRef<EditCustomerPopupHandle>(null);
  const gridRef = useRef<DataGridRef>(null);

  function openDipendenzePopup(e: any) {
    dipendenzeRef.current?.show(e.row.key);
  }

  function dataGridInitNewRow(e: any) {
    e.data.ragioneSociale = "Prova";
  }

  function new_click(e: any) {
    editCustomerRef.current?.new();
  }

  function edit_click(e: any) {
    editCustomerRef.current?.edit(e.row.data.id);
  }

  function refreshGrid() {
    // console.log('refresh clienti');
    gridRef.current?.instance().refresh();
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>{t('clienti')}</h2>
      <DataGrid
        ref={gridRef}
        className={'dx-card wide-card'}
        dataSource={customersDataSource("")}
        showBorders={false}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnAutoWidth={true}
        errorRowEnabled={false}
        columnHidingEnabled={true}
        onRowUpdating={function (e) { e.newData = Object.assign({}, e.oldData, e.newData) }}
        onDataErrorOccurred={dataGridErrorHandling}
        onInitNewRow={dataGridInitNewRow}
      >
        <Editing
          mode="popup"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}>
        </Editing>
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        <FilterRow visible={true} />
        <Toolbar>
          <Item location="after">
            <Button
              icon='add'
              onClick={new_click}
            />
          </Item>
        </Toolbar>
        <Column type='buttons' >
          <GridButton name="edit" hint={t ('modifica')} onClick={edit_click} />
          <GridButton name="delete" hint={t ('elimina')}/>
          <GridButton hint={t ('depositi')} icon="product" onClick={openDipendenzePopup} />
        </Column>
        <Column dataField={'id'} width={90} hidingPriority={1} allowEditing={false} visible={false} showEditorAlways={false} />
        <Column dataField={'ragioneSociale'} caption={t ('ragioneSociale')} sortIndex={0} sortOrder="asc" />
        <Column dataField={'codiceFiscale'} caption={t ('codiceFiscale')} />
        <Column dataField={'partitaIva'} caption={t ('partitaIva')}/>
        <Column dataField={'indirizzo'} caption={t ('indirizzo')}/>
        <Column dataField={'cap'} caption={t ('cap')}/>
        <Column dataField={'citta'} caption={t ('citta')}/>
        <Column dataField={'provinciaCodice'} caption={t ('provinciaCodice')}/>
        <Column dataField={'provinciaDescrizione'} caption={t ('provinciaDescrizione')}/>
        <Column dataField={'nazioneCodice'} caption={t ('nazioneCodice')}/>
        <Column dataField={'nazioneDescrizione'} caption={t ('nazioneDescrizione')} />
        <Column dataField={'telefono'} caption={t ('telefono')}/>
        <Column dataField={'mobile'} caption={t ('mobile')}/>
        <Column dataField={'email'} caption={t ('email')}/>
        <Column dataField={'pec'} caption={t ('pec')}/>
        <Column dataField={'codiceUnicocoSDI'} caption={t ('codiceUnicocoSDI')}/>
        <Column dataField={'formaGiuridicaId'} caption={t ('formaGiuridicaId')}/>
        <Column dataField={'formaGiuridicaDescrizione'} caption={t ('formaGiuridicaDescrizione')}/>
        <Column dataField={'pagmentoCodice'} caption={t ('pagmentoCodice')}/>
        <Column dataField={'pagmentoDescrizione'} caption={t ('pagmentoDescrizione')}/>
        <Column dataField={'listinoCodice'} visible={false}/>
        <Column dataField={'listinoDescrizione'} caption={t ('listinoDescrizione')}/>
        <Column dataField={'affidabilitaPunteggio'} caption={t ('affidabilitaPunteggio')}/>
        <Column dataField={'importoMinimoOrdine'} caption={t ('importoMinimoOrdine')}/>
      </DataGrid>

      <PopupDipendenze ref={dipendenzeRef}></PopupDipendenze>
      <PopupEditCustomer ref={editCustomerRef} onChange={refreshGrid}></PopupEditCustomer>
    </React.Fragment>
  )
}

